<template lang="pug">
.w3-container.w3-card.no_pad_all.status_panel.w3-display-container(:class="isMajor ? '' : 'w3-margin-left w3-margin-right'")
  .icon_area.w3-display-position(class="{{{ data.type.name }}}_icon")
    img.w3-display-middle.icon_size(v-bind:src="getIconPath(data.type.name)")
  .w3-panel.info_area.w3-display-center
    .info_text
      .info_title(:class="data.type.texTransform") {{ data.type.name }}
      .info_description {{ data.description }}
    .w3-light-grey.w3-round.w3-animate-opacity.w3-display-container(v-if="data.progressbarIsNeeded")
      .w3-display-middle(
        v-bind:style="{color: data.percentage >= 60 ? '#FFF' : '#000'}"
      ) {{ data.percentage }}%
      .w3-round.w3-tiny.w3-text-dark-grey(
        v-bind:style="{height: 20 + 'px', width: (data.percentage > 100 ? '100' : data.percentage) + '%', backgroundColor: getStatusColor(data.percentage)}"
      )
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
      isMajor: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getIconPath (name) {
        const iconPath = {
          mail: '../../../static/svg/mail.svg',
          price: '../../../static/svg/price.svg',
          sms: '../../../static/svg/sms.svg'
        }
        return iconPath[name]
      },
      getStatusColor (status) {
        /* decide progress color into three part */
        const statusDivider = _.floor(status / 33)
        switch (statusDivider) {
          case 0:
            return '#4CAF50'
          case 1:
            return '#ff9800'
          default:
            return '#f44336'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  
  $icon_width: 100px;

  .status_panel {
    min-height: $icon_width;
    height: 100%;
    margin-bottom: 16px;
  }
  .icon_area {
    display: inline-block;
    min-height: $icon_width;
    height: 100%;
    width: $icon_width;
    .icon_size {
      width: 60%;
    }
  }
  .info_area {
    display: inline-block;
    min-height: 65.5px;
    width: calc(100% - #{$icon_width});
    margin-left: $icon_width;
    .info_text {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      font-size: 18px;
    }
    .info_title {
      font-size: 24px;
    }
  }
  .mail_icon {
    background-color: #00c0ef !important;
  }
  .sms_icon {
    background-color: #00a65a !important;
  }
  .price_icon {
    background-color: #d14a38 !important;
  }
</style>


// WEBPACK FOOTER //
// NotifyBlock.vue?389e3019